import script from "./TeachView.vue?vue&type=script&setup=true&lang=js"
export * from "./TeachView.vue?vue&type=script&setup=true&lang=js"

import "./TeachView.vue?vue&type=style&index=0&id=394fbcaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394fbcaf"]])

export default __exports__